// src/routes/servicesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Services from '../pages/services/Services';
import CreateService from '../pages/services/CreateService';
import EditService from '../pages/services/EditService';
import ProtectedRoute from '../components/global/ProtectedRoute';

const servicesRoutes = (
    <>
        {/* Services List */}
        <Route
            path="/services"
            element={
                <ProtectedRoute requiredPermission="services_list">
                    <Services />
                </ProtectedRoute>
            }
        />

        {/* Services Archive */}
        <Route
            path="/services/archive"
            element={
                <ProtectedRoute requiredPermission="services_archive_list">
                    <Services />
                </ProtectedRoute>
            }
        />

        {/* Create Service */}
        <Route
            path="/services/create"
            element={
                <ProtectedRoute requiredPermission="services_create">
                    <CreateService />
                </ProtectedRoute>
            }
        />

        {/* Edit Service */}
        <Route
            path="/services/:id/edit"
            element={
                <ProtectedRoute requiredPermission="services_edit">
                    <EditService />
                </ProtectedRoute>
            }
        />
    </>
);

export default servicesRoutes;
